export const formatTime = (time24) => {
  const hours = Math.floor(time24);
  const minutes = (time24 % 1) * 60;
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes === 0 ? "00" : minutes;
  return `${formattedHours}:${formattedMinutes} ${period}`;
};
